import styles from "./styles.scss";

const Alert = ({title, message, options = {}, onDismiss, component}) => {
  return <div className={styles.modalContainer}>
    {component}
    {!component && <div className={styles.modal}>
      <div className={styles.modalTitle}>{title}</div>
      <div className={styles.modalMessage}>{message}</div>
      {options.btn1 && <button className={styles.modalDismissButton} onClick={options.btn1.onClick}>{options.btn1.title}</button>}
      {!options.hideDismiss && <button className={styles.modalDismissButton} onClick={onDismiss}>OK</button>}
    </div>}
  </div>
};

export default Alert;



// WEBPACK FOOTER //
// ./components/alert/index.js